module.exports = __webpack_public_path__ + "img/1.50f419f8.png";